import { Tour, type TourProps } from "antd";

/** Seen-flag key, scoped per workspace so a newly created workspace gets the tour again. */
export const welcomeTourKey = (workspaceId?: string) =>
	workspaceId ? `artemis-tour-seen-${workspaceId}` : "artemis-tour-seen";

// antd Menu items render a `data-menu-id` attribute suffixed with the item key
// (the route path). Suffix-match it to find the nav element to point the step at.
const navTarget = (keySuffix: string) => () =>
	// null (e.g. off a workspace page) is fine — antd centers the step.
	document.querySelector(`[data-menu-id$="${keySuffix}"]`) as HTMLElement;

export function WelcomeTour({
	open,
	onClose,
	storageKey = welcomeTourKey(),
}: {
	open: boolean;
	onClose: () => void;
	storageKey?: string;
}) {
	const steps: TourProps["steps"] = [
		{
			title: "1. Connect your environments",
			description:
				"Start here — link your cloud accounts and clusters so StratoNext can discover the applications you already run.",
			target: navTarget("/environments"),
		},
		{
			title: "2. Create projects & deployments",
			description:
				"Group your applications into Projects and track their deployments to build a live map of what you operate.",
			target: navTarget("/projects"),
		},
		{
			title: "3. Deploy agents",
			description:
				"Run intelligent agents against your environments to automate operational work in the background.",
			target: navTarget("/agents"),
		},
		{
			title: "4. Coordinate with tasks",
			description:
				"Create Tasks to hand work to your agents and coordinate delivery across your team.",
			target: navTarget("/tasks"),
		},
	];

	const dismiss = () => {
		localStorage.setItem(storageKey, "1");
		onClose();
	};

	return (
		<Tour open={open} onClose={dismiss} onFinish={dismiss} steps={steps} />
	);
}
